export enum OrderType {
    Import = 3,
    Domestic = 1,
    Export = 2,
    Return = 4,
    B2BImport = 5
}